import React, { type FC, type PropsWithChildren } from 'react';

import { withImage } from '@lucid/hooks';

import Box from '../../../components/box/box';
import Heading from '../../../components/heading/heading';
import ImageWithPlaceholder from '../../../components/image/image-with-placeholder';
import Text from '../../../components/text/text';
import type { ComponentImage } from '../../../types/generics';
import type { Lucid } from '../../../types/types';

export interface HorizontalCardProps extends ComponentImage {
  footer: string;
  title: string;
  /** Allows the component to get additional styles. */
  className?: string;
  size?: 'large' | 'medium';
  tag?: string;
}

const HorizontalCard: FC<PropsWithChildren<HorizontalCardProps>> = ({
  className,
  imageAlt,
  imageSrc,
  footer,
  title,
  size = 'medium',
  tag,
}) => (
  <Box
    css={{ label: 'horizontalCard', alignItems: 'center', display: 'grid' }}
    // eslint-disable-next-line @stylistic/jsx-sort-props
    className={className}
  >
    <ImageWithPlaceholder
      alt={imageAlt || ''}
      aspectRatio="1:1"
      src={
        withImage({
          filename_disk: imageSrc,
        } as Lucid.Directus.Generated.Directus_Files) || ''
      }
    />
    <Box
      css={theme => ({
        padding: theme.space.s16,
      })}
    >
      {tag && (
        <Text css={theme => ({ marginBottom: theme.space.s8 })} data-testid="horizontal-card-tag" variant="labelXS400">
          {tag}
        </Text>
      )}
      <Heading
        as="h6"
        css={theme => ({ marginBottom: theme.space.s16 })}
        variant={size === 'medium' ? 'headingM' : 'headingL'}
      >
        {title}
      </Heading>
      <Text variant="paragraphS400">{footer}</Text>
    </Box>
  </Box>
);

export default HorizontalCard;
export { HorizontalCard };
